import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Tilt from "react-parallax-tilt";

function Home2() {
    return (
        <Container fluid className="home-about-section" id="about">
            <Container>
                <Row>
                    <Col md={8} className="home-about-description">
                        <h1 style={{fontSize: "2.6em"}}>
                            <span className="purple"> ABOUT ME </span>
                        </h1>
                        <p className="home-about-body center">
                            I research ways to use <i className="purple font-weight-bold center">Machine Learning</i> methods for generating actionable insights from data. Experienced in collecting, organizing, interpreting, and disseminating various types of statistical figures.
                        </p>

                        <p className="home-about-body">
                            I am fluent in
                            <i>
                                <b className="purple"> Python, SQL & Tableau. </b>
                            </i>

                            {/*(Recently I've started learning a few functional programing languages like <i>*/}
                            {/*<b className="purple"> Smalltalk & Lisp </b>*/}
                        {/*</i> )*/}

                         I am a powerful presenter and sure communicator with the ability to communicate information in a simple, reliable, and beneficial manner to end users. Innovative in problem-solving and evaluating adjustments to ensure the best possible use of organizational data.

                        </p>
                    </Col>
                    <Col md={4} className="myAvtar">
                        <Tilt>
                            <img src={myImg} className="img-fluid" alt="avatar"/>
                        </Tilt>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="home-about-social">
                        <h1>TALK TO ME</h1>
                        <p>
                            Feel free to <span className="purple">connect </span>with me
                        </p>
                        <ul className="home-about-social-links">
                            <li className="social-icons">
                                <a
                                    href="https://github.com/rishidhaka/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour  home-social-icons"
                                >
                                    <i className="fab fa-github"/>
                                </a>
                            </li>
                            {/*<li className="social-icons">*/}
                            {/*    <a*/}
                            {/*        href="https://twitter.com/Soumyajit4419"*/}
                            {/*        target="_blank"*/}
                            {/*        rel="noreferrer"*/}
                            {/*        className="icon-colour  home-social-icons"*/}
                            {/*    >*/}
                            {/*        <i className="fab fa-twitter"></i>*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                            <li className="social-icons">
                                <a
                                    href="https://www.linkedin.com/in/rishi-dhaka/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour  home-social-icons"
                                >
                                    <i className="fab fa-linkedin-in"/>
                                </a>
                            </li>
                            <li className="social-icons">
                                <a
                                    href="https://www.instagram.com/dhakatouille/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour home-social-icons"
                                >
                                    <i className="fab fa-instagram"/>
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Home2;
